function RateAutomatic(props) {
  return <>RateAutomatic</>;
}

export default RateAutomatic;
